import React from 'react';
import {classes, style} from './doppe-viewer-video-player-overlay.st.css';
import {WixVideoResourcePlayer} from "@wix/devzai-common-client";
import {
    cssAbsoluteStretchInOffsetParent,
    cssFullWidthAndHeight,
    flexCenterContent,
    Icon
} from "@wix/devzai-utils-react";
import {
    DoppeActionTypeVideoIcon
} from "../../doppe-action-types/doppe-action-type-videos-list/doppe-action-type-videos-list-icons";
import {DoppePageMediaView} from "../doppe-page-media-view/doppe-page-media-view";

export const DoppeViewerVideoPlayerOverlay = React.memo(function DoppeViewerVideoPlayerOverlay (props: DoppeViewerVideoPlayerOverlay.Props) {
    const {
        overlayRenderProps,
        widthSpec,
        layoutSpec,

        className,
        ...htmlAttributes
    } = props;

    const {
        poster,
    } = overlayRenderProps;

    return (
        <div
            {...htmlAttributes}
            className={style(classes.root, className)}
        >
            {poster ? (
                <DoppePageMediaView
                    className={style(classes.poster, cssFullWidthAndHeight())}
                    mediaResource={poster}
                    widthSpec={widthSpec}
                    layoutSpec={layoutSpec}
                />
            ) : null}
            <div
                className={style(classes.posterOverlay, cssAbsoluteStretchInOffsetParent(), flexCenterContent())}
            >
                <Icon
                    className={style(classes.playIcon, {})}
                    icon={DoppeActionTypeVideoIcon}
                />
            </div>
        </div>
    );
});

export namespace DoppeViewerVideoPlayerOverlay {

    export interface Props extends React.HTMLAttributes<any>, Pick<DoppePageMediaView.Props, 'widthSpec' | 'layoutSpec'> {
        overlayRenderProps: WixVideoResourcePlayer.OverlayRenderProps;
    }
}
